<template>
  <div
    class="content app-content"
    :class="[
      {
        'show-overlay': $store.state.app.shallShowOverlay,
        'fit-screen': fitScreen,
        'only-nav-bar': hasOnlyNavBar
      },
      $route.meta.contentClass,
    ]"
  >
    <div class="content-overlay" />
    <!-- <div :class="hasOnlyNavBar?'':(hasNavbarShadow ? 'header-navbar-shadow' : '')" /> -->
    <div
      class="content-wrapper"
      :class="contentWidth === 'boxed' ? 'container p-0' : null"
      :style="contentWrapperStyle"
    >
      <slot name="breadcrumb">
        <app-breadcrumb />
      </slot>
      <div class="content-body" :class="hasOnlyNavBar?'no-content-body-margin':''">
        <transition
          :name="routerTransition"
          mode="out-in"
          @before-enter="handleBeforeEnter"
          @after-enter="handleAfterEnter"
        >
          <slot />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';
import useAppConfig from '@core/app-config/useAppConfig';
import {
  menuItems,
  backofficeDetailsRoutes,
} from '@/backoffice/constants/backofficeMenu';
import { myselfMenuItems } from '@/views/myself/components/myMenu';
import GridStatusMixin from '@core/mixins/apps-layout/GridStatusMixin';

export default {
  components: {
    AppBreadcrumb,
  },
  mixins: [GridStatusMixin],

  props: {
    fitScreen: Boolean,
  },
  provide() {
    return {
      hasEntered: () => this.hasEntered,
    };
  },
  data() {
    return { hasEntered: false, isSmall: '' };
  },
  setup() {
    const { routerTransition, contentWidth } = useAppConfig();

    return {
      routerTransition,
      contentWidth,
    };
  },
  computed: {
    isHome() {
      return this.$route.name === 'Resumen';
    },
    isNexos() {
      return process.env.VUE_APP_CUSTOMER === 'nexos';
    },
    isVerticalLayout() {
      return this.contentLayoutType === 'vertical';
    },
    isMobile() {
      return window.innerWidth < 1000;
    },
    contentLayoutType() {
      if (this.isMobile) {
        return 'vertical';
      }
      if (this.$route.path.includes('/backoffice') || this.$route.path.includes('/myself')) {
        return 'vertical';
      }
      if (this.$store.getters.currentCollective.menu?.layout) {
        return this.$store.getters.currentCollective.menu.layout;
      }
      return this.$store.state.appConfig.layout.type;
    },
    hasNavbarShadow() {
      return (
        this.isVerticalLayout
        || this.activatedApps.length > 0
        || this.hasBackofficeMenu
        || this.hasBOBreadcrumb
        || this.hasMyselfMenu
      );
    },
    hasNotMenu() {
      return (
        this.$route.name === 'welcome'
        || menuItems.includes(this.$route.name)
        || this.$route.name === 'globalMemberSettings'
        || this.$route.name === 'myRoles'
        || this.$route.name === 'myself-subcommunities'
        || this.$route.name === 'myConnections'
        || this.$route.name === 'calendar'
        || this.$route.name === 'myDashboard'
        || this.$route.name === 'email'
        || this.$route.name === 'myself-subscription'
        || this.$route.name === 'onboarding-form'
        || this.$route.name === 'onboarding-plans'
        || this.$route.name === 'onboarding-checkout'
        || this.$route.name === 'onboarding-success'
        || this.$route.name === 'myself-referrals'
        || this.$route.name === 'orders'
        || this.$route.name === 'my-payments'
        || this.$route.name === 'passport'
        || this.$route.name === 'myself-notifications'
        || this.$route.name === 'developers-center'
        || this.$route.name === 'my-role-details'
        || this.$route.name === 'myself-likes'
      );
    },
    hasOnlyNavBar() {
      return (
        this.$route.name === 'forms-detail'
        || this.$route.name === 'forms-success'
        || this.$route.name === 'onboarding-form'
      );
    },
    hasBackofficeMenu() {
      return menuItems.includes(this.$route.name);
    },
    hasMyselfMenu() {
      return (
        myselfMenuItems.includes(this.$route.name)
        || this.$route.name === 'my-role-details'
      );
    },
    hasBOBreadcrumb() {
      return (
        backofficeDetailsRoutes.includes(this.$route.name)
        || this.$route.name === 'my-role-details'
      );
    },
    activatedApps() {
      const { apps } = this.$store.getters.apps;
      if (!apps) {
        return {};
      }
      return Object.values(apps).filter((app) => app?.isInMenu);
    },
    contentWrapperStyle() {
      const marginTopStyleCalc = this.calculateMarginTopStyle;
      // console.log('marginTopStyleCalc:', marginTopStyleCalc);
      return marginTopStyleCalc;

      // console.log('this.hasBOBreadcrumb:', this.hasBOBreadcrumb);
      // console.log('this.isMobile:', this.isMobile);
      // console.log('this.hasOnlyNavBar:', this.hasOnlyNavBar);
      // console.log('this.hasBackofficeMenu:', this.hasBackofficeMenu);
      // console.log('this.hasMyselfMenu:', this.hasMyselfMenu);
      // console.log('this.contentLayoutType:', this.contentLayoutType);
      // console.log('this.hasNotMenu:', this.hasNotMenu);
      const marginTopStyle = this.hasBOBreadcrumb
          ? 'margin-top: 3rem'
          : this.isMobile || this.hasOnlyNavBar
          ? 'margin-top: 0;'
          : ((this.hasBackofficeMenu || this.hasMyselfMenu) && this.contentLayoutType !== 'vertical')
          ? 'margin-top: 4.5rem;'
          : this.hasNotMenu || this.$route.name === 'calendar' || this.contentLayoutType === 'vertical'
          ? 'margin-top: -35px'
          : this.activatedApps.length <= 0
          ? 'margin-top: -30px;'
          : this.isHome
          ? 'margin-top: 4.5rem;'
          : 'margin-top: 3.5rem;';
      console.log('marginTopStyle:', marginTopStyle);
      return marginTopStyle;
    },
    
    calculateMarginTopStyle() {
      // console.log('calculateMarginTopStyle...');
      // Priority 1: Backoffice breadcrumb pages
      if (this.hasBOBreadcrumb) {
        // console.log('1) hasBOBreadcrumb');
        return 'margin-top: 3rem';
      }
      
      // Priority 2: Mobile or pages with only navbar
      if (this.isMobile || this.hasOnlyNavBar) {
        // console.log('this.isMobile:', this.isMobile);
        // console.log('this.hasOnlyNavBar:', this.hasOnlyNavBar);

        // console.log('2) isMobile || hasOnlyNavBar');
        return 'margin-top: 0';
      }

      const contentLayoutIsVertical = this.contentLayoutType === 'vertical';
      // console.log('contentLayoutIsVertical:', contentLayoutIsVertical);
      
      // Priority 3: Backoffice or Myself menu with non-vertical layout
      if ((this.hasBackofficeMenu || this.hasMyselfMenu) && !contentLayoutIsVertical) {
        // console.log('this.hasBackofficeMenu:', this.hasBackofficeMenu);
        // console.log('this.hasMyselfMenu:', this.hasMyselfMenu);

        // console.log('3) hasBackofficeMenu || hasMyselfMenu && contentLayoutType !== vertical');
        return 'margin-top: 4.5rem';
      }

      const routeIsCalendar = this.$route.name === 'calendar';
      
      // Priority 4: Pages without menu, calendar, or vertical layout
      if (this.hasNotMenu || routeIsCalendar || contentLayoutIsVertical) {
        // console.log('this.hasNotMenu:', this.hasNotMenu);
        // console.log('routeIsCalendar:', routeIsCalendar);
        // console.log('contentLayoutIsVertical:', contentLayoutIsVertical);

        // console.log('4) hasNotMenu || $route.name === calendar || contentLayoutType === vertical');
        return 'margin-top: -60px';
      }

      const hasNoActivatedApps = this.activatedApps.length <= 0;
      // console.log('hasNoActivatedApps:', hasNoActivatedApps);
      
      // Priority 5: Pages with no activated apps
      if (hasNoActivatedApps) {
        // console.log('5) activatedApps.length <= 0');
        return 'margin-top: -30px';
      }
      
      // Priority 6: Home page
      if (this.isHome) {
        // console.log('6) isHome');
        return 'margin-top: 4.5rem';
      }
      
      // Priority 7: Default case - pages with activated apps
      // console.log('7) Default case');
      return 'margin-top: 3.5rem';
    },
  },
  created() {
    // console.log("this.$route.name:", this.$route.name);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleBeforeEnter() {
      this.hasEntered = false;
    },
    handleAfterEnter() {
      this.hasEntered = true;
    },
    handleResize() {
      this.isSmall = window.innerWidth <= 1200;
    },
  },
};
</script>

<style lang="scss" scoped>
.fit-screen {
  &.app-content {
    height: 100vh;
  }
  .content-wrapper {
    height: 100%;
  }
}

.content {
  position: relative;
  transition: all 0.3s ease;
  
  &.show-overlay::after {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }
}

.content-body {
  position: relative;
  min-height: calc(100vh - 4.5rem);
  
  &.no-content-body-margin {
    margin-top: 0;
  }

  // Mobile-specific styles
  @media (max-width: 767px) {
    min-height: calc(100vh - 3.5rem);
    padding: 0.5rem;
    
    // Improve grid layout on mobile
    .grid-layout {
      display: grid;
      grid-template-columns: 1fr;
      gap: 1rem;
      padding: 0.5rem;
      
      // Ensure elements take full width on mobile
      > * {
        width: 100% !important;
        margin: 0 !important;
      }
    }

    // Adjust spacing for home page
    .home-page {
      padding: 0.5rem;
      
      .grid-layout {
        margin: 0;
        padding: 0.5rem;
      }
    }
  }
}

.content-wrapper {
  position: relative;
  min-height: 100%;
  padding: 2.2rem 2.5rem 0;
  transition: all 0.3s ease;

  @media (max-width: 767px) {
    padding: 0;
    
    // Adjust container padding on mobile
    &.container {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
  }
}

// Improve transitions
.v-enter-active,
.v-leave-active {
  transition: all 0.3s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
